// extracted by mini-css-extract-plugin
export default {"tipContainer":"MUICard_tipContainer__kJoE7","tipCardMain":"MUICard_tipCardMain__Z3P8U","cardHeader":"MUICard_cardHeader__suynf","tipsListWrapper":"MUICard_tipsListWrapper__dIoJ6"};